import { useMemo } from 'react';
import { CallIntelligenceV2 } from '@frontend/api-call-intel';
import { TaskCenterTypes } from '@frontend/api-task-center';
import { useIsCallIntelEligibleAccount } from '@frontend/call-intel-core';

export const useGetFirstCallIntelAutoAssignedTaskId = (
  locationIds: string[],
  list: TaskCenterTypes.Task[] | undefined
) => {
  const { isCallIntelActive, activeLocationIds } = useIsCallIntelEligibleAccount(locationIds);

  // Fetch call intel AI task settings and map by location ID
  const { data: callIntelAiTaskSettingMap } = CallIntelligenceV2.Queries.useListAITaskSettingsQuery({
    request: {
      locationIds: activeLocationIds,
    },
    options: {
      enabled: activeLocationIds.length > 0,
      select: (response) => {
        return response.results?.reduce((acc, setting) => {
          acc[setting.locationId] = setting;
          return acc;
        }, {} as Record<string, CallIntelligenceV2.Types.AITaskSetting>);
      },
    },
  });

  return useMemo(() => {
    if (!isCallIntelActive) {
      return undefined;
    }
    return list?.find(
      (task) =>
        task.source === TaskCenterTypes.TaskSource.SOURCE_CALL_INTELLIGENCE && // ensure the task is from Call Intelligence
        task.createdBy === 'weave-ai' && // ensure the task was created by the AI
        !!task.assignee && // ensure the task has an assignee
        callIntelAiTaskSettingMap?.[task.locationId]?.autoAssignTaskEnabled // check if auto-assign is enabled for the location
    )?.id;
  }, [isCallIntelActive, list, callIntelAiTaskSettingMap]);
};
